import {
  EMPLOYEE_PERMISSION_PAGE_REQUEST,
  EMPLOYEE_PERMISSION_SUBMIT_FORM,
  EMPLOYEE_PERMISSION_SET_SETTING,
  EMPLOYEE_PERMISSION_CHANGE_PAGE,
} from './constants';

export function pageRequest() {
  return { type: EMPLOYEE_PERMISSION_PAGE_REQUEST, payload: {} };
}

export function submitForm(data, params) {
  return { type: EMPLOYEE_PERMISSION_SUBMIT_FORM, payload: { data, params } };
}

export function setSetting(setting) {
  return { type: EMPLOYEE_PERMISSION_SET_SETTING, payload: { setting } };
}

export function changePage(pathname) {
  return { type: EMPLOYEE_PERMISSION_CHANGE_PAGE, payload: { pathname } };
}
